export default __webpack_public_path__ + "static/hero-bg-desktop-18107d8f30377b83cb521b8fe2e47543.jpg";